/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleApi from './api/moduleApi.js'
import modules from './modules'
import vuexPersistedstate from 'vuex-plugin-persistedstate'


Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    // calendar: moduleCalendar,
    // chat: moduleChat,
    // email: moduleEmail,
    ...modules,
    auth: moduleAuth,
    eCommerce: moduleECommerce,
    api: moduleApi
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    vuexPersistedstate({
      paths: ['api']
    })
  ]
})
